// extracted by mini-css-extract-plugin
module.exports = {"check":"IconCheck_check__29TtX","behind":"IconCheck_behind__3-d-y"};